import { Permissions, type User } from '@/models/user';

export const isPathsManager = (user: User) =>
  user?.permissoes?.some(
    (permission) => permission?.nome === Permissions.PathsManager
  ) ?? false;
